<template>
  <div class="pa-character-application-list-loading-set">
    <transition name="pa-simple-fade" @enter="handleEnter" @afterEnter="handleAfterEnter" @afterLeave="handleAfterLeaveContent">
      <div class="content-field" v-if="isOpenContent" ref="contentField">
        <div class="logo">
          <TokeiCityLogo />
        </div>
        <p class="text caption">ー&nbsp;塔経市帝電子行政基盤&nbsp;ー</p>
        <p class="text">申請状況の確認中です。</p>
        <p class="text">しばらくお待ちください。</p>
      </div>
    </transition>

    <transition name="pa-simple-fade" @afterEnter="handleAfterEnterOverlay">
      <div class="overlay-field" v-if="isOpenOverlay" ref="overlayField"></div>
    </transition>
  </div>
</template>

<script>
import TokeiCityLogo from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsCheckApplicationStatus/Images/tokei-city-logo.svg?inlineN'

export default {
  props : {
    isLoading : {
      default: false
    },

    boxHeight : {
      default: 0
    },
  },

  components : {
    TokeiCityLogo
  },

  data(){
    return {
      isOpenContent       : false,
      isOpenOverlay       : false
    };
  },

  watch : {
    isLoading : {
      handler(value){
        if(value === true){
          this.isOpenOverlay = true;
        }else{
          this.isOpenContent = false;
        }
      },
      immediate: true
    },

    boxHeight : {
      handler(){
        this.setBoxHeight();
      },
      immediate: true
    }
  },

  methods : {
    setBoxHeight(){
      if(this.boxHeight === 0) return;
      if(typeof this.$refs.contentField === 'undefined') return;
      if(typeof this.$refs.overlayField === 'undefined') return;

      const size = this.boxHeight+'px';

      this.$refs.contentField.style.height = size;
      this.$refs.overlayField.style.height = size;
    },

    handleEnter(){
      this.setBoxHeight();
    },

    handleAfterEnter(){
      this.$parent.$parent.$parent.$emit('requestScrollBotom');
    },

    handleAfterEnterOverlay(){
      this.isOpenContent = true;
    },

    handleAfterLeaveContent(){
      this.isOpenOverlay = false;
    }
  },

  mounted(){
    this.setBoxHeight();
  }
}
</script>

<style lang="scss">
@keyframes rotateY {
  0% {
    -webkit-transform:rotateY(0deg);
    -moz-transform:rotateY(0deg);
    transform:rotateY(0deg);
  }
  25% {
    -webkit-transform:rotateY(90deg);
    -moz-transform:rotateY(90deg);
    transform:rotateY(90deg);
  }
  50% {
    -webkit-transform:rotateY(180deg);
    -moz-transform:rotateY(180deg);
    transform:rotateY(180deg);
  }
  75% {
    -webkit-transform:rotateY(270deg);
    -moz-transform:rotateY(270deg);
    transform:rotateY(270deg);
  }
  100% {
    -webkit-transform:rotateY(360deg);
    -moz-transform:rotateY(360deg);
    transform:rotateY(360deg);
  }
}

.pa-character-application-list-loading-set{
  .content-field, .overlay-field{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    min-height: 200px;
  }

  .content-field{
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div.logo{
      text-align: center;
      svg{
        width:70px;

        .a{fill:#709c8d;}

        -webkit-animation:rotateY 2.5s ease-out 0s infinite;
        -moz-animation:rotateY 2.5s ease-out 0s infinite;
        animation:rotateY 2.5s ease-out 0s infinite;        
      }
    }

    p{
      &.text{
        font-size:.95rem;
        margin-bottom:0;
        text-align: center;
        color:#B5E2D2;
        color:#81b1a0;
        color:#709c8d;
        // text-shadow: 0 0 50px #B5E2D2;
        text-shadow: 0 0 50px #ffffff;
      }

      &.caption{
        font-size:.7rem !important;
        margin-bottom:.5rem !important;
      }
    }
  }

  .overlay-field{
    z-index: 1;
    background-color:rgba(181, 226, 210, 0.4);
    backdrop-filter: blur(3px);
  }
}

.pa-message-set{
  &-default{
    .pa-character-application-list-loading-set{
      .content-field{
        div.logo{
          svg{
            .a{fill:#709c8d;}
          }
        }

        p{
          &.text{
            color:#709c8d;
            text-shadow: 0 0 50px #ffffff;
          }
        }
      }
      
      .overlay-field{
        background-color:rgba(181, 226, 210, 0.4);
      }
    }
  }

  &-lilica{
    .pa-character-application-list-loading-set{
      .content-field{
        div.logo{
          svg{
            .a{fill:#9c708a;}
          }
        }

        p{
          &.text{
            color:#9c708f;
            text-shadow: 0 0 50px #ffffff;
          }
        }
      }
      
      .overlay-field{
        background-color:rgba(226, 181, 220, 0.4);
      }
    }
  }
}
</style>